import { createFileRoute } from '@tanstack/react-router';
import { CustomerScreen, customerSearchSchema } from '../../../features/customers/customer-screen';

/**
 * Tabul deschis stă în `?tab=`, nu în starea componentei: altfel un refresh — sau butonul
 * „Înapoi" — aduce fișa înapoi pe „Detalii client", iar operatorul care se uita la servicii
 * își pierde locul.
 *
 * Consecința asumată, cea pentru care tabul fusese ținut local: adresa trimisă prin mesaj
 * poartă acum și tabul meu. E preferabilă pierderii locului la fiecare reîncărcare, iar
 * fișa se deschide oricum corect — cine primește linkul vede tabul din el.
 */
export const Route = createFileRoute('/_authenticated/clienti/$customerId')({
  validateSearch: customerSearchSchema,
  component: FisaClient,
});

function FisaClient() {
  const { customerId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <CustomerScreen
      customerId={customerId}
      tab={tab}
      // `replace`: schimbarea tabului nu e un pas în istoric. Altfel „Înapoi" ar parcurge
      // taburile pe care le-am deschis, în loc să se întoarcă la listă.
      onTabChange={(next) => navigate({ search: { tab: next }, replace: true })}
    />
  );
}
